/** Independent copy of the current Steam Punk expedition artwork map.
 * Chapter boundaries and provenance are recorded in docs/320; no remote runtime. */
export const steamChapters = [
  {
    id: 'last-boiler-tavern',
    title: 'The Last Boiler',
    fromLevel: 1,
    noticeLine: 'Professor Prometheus recruits a crew where the boilers still sing.',
    src: '/assets/steam-punk/backdrop-01-the-last-boiler-v2.webp',
    chapterNumber: 1,
  },
  {
    id: 'investors',
    title: 'The Investors',
    fromLevel: 101,
    noticeLine: 'The expedition finds funding, which is not the same as wisdom.',
    src: '/assets/steam-punk/backdrop-02-the-investors-v2.webp',
    chapterNumber: 2,
  },
  {
    id: 'dry-dock',
    title: 'The Dry Dock',
    fromLevel: 201,
    noticeLine: 'Brass, boilerplate, and bad judgment become a ship.',
    src: '/assets/steam-punk/backdrop-03-the-dry-dock-v2.webp',
    chapterNumber: 3,
  },
  {
    id: 'first-launch',
    title: 'First Launch',
    fromLevel: 301,
    noticeLine: 'The impossible machine leaves the dock under steam.',
    src: '/assets/steam-punk/backdrop-04-first-launch-v2.webp',
    chapterNumber: 4,
  },
  {
    id: 'outer-belt',
    title: 'The Outer Belt',
    fromLevel: 401,
    noticeLine: 'The crew crosses rock, rust, and unpaid invoices.',
    src: '/assets/steam-punk/backdrop-05-the-outer-belt-v2.webp',
    chapterNumber: 5,
  },
  {
    id: 'great-drift',
    title: 'The Great Drift',
    fromLevel: 501,
    noticeLine: 'The stars widen, and the plan starts leaking confidence.',
    src: '/assets/steam-punk/backdrop-06-the-great-drift-v2.webp',
    chapterNumber: 6,
  },
  {
    id: 'warp-experiment',
    title: 'The Warp Experiment',
    fromLevel: 601,
    noticeLine: 'One clever shortcut bends the route out of shape.',
    src: '/assets/steam-punk/backdrop-07-the-warp-experiment-v2.webp',
    chapterNumber: 7,
  },
  {
    id: 'wrong-place',
    title: 'The Wrong Place',
    fromLevel: 701,
    noticeLine: 'The expedition arrives where no investor meant to pay for.',
    src: '/assets/steam-punk/backdrop-08-the-wrong-place-v2.webp',
    chapterNumber: 8,
  },
  {
    id: 'ghost-system',
    title: 'The Ghost System',
    fromLevel: 801,
    noticeLine: 'Dead machinery and stranger gravity mark the path.',
    src: '/assets/steam-punk/backdrop-09-the-ghost-system-v2.webp',
    chapterNumber: 9,
  },
  {
    id: 'discovery',
    title: 'The Discovery',
    fromLevel: 901,
    noticeLine: 'The neutron star is real. So is the danger.',
    src: '/assets/steam-punk/backdrop-10-the-discovery-v2.webp',
    chapterNumber: 10,
  },
  {
    id: 'approach',
    title: 'The Approach',
    fromLevel: 1001,
    noticeLine: 'The ship closes in where brass was never meant to survive.',
    src: '/assets/steam-punk/backdrop-11-the-approach-v2.webp',
    chapterNumber: 11,
  },
  {
    id: 'chaos-orbit',
    title: 'The Chaos Orbit',
    fromLevel: 1101,
    noticeLine: 'Every orbit becomes a negotiation with disaster.',
    src: '/assets/steam-punk/backdrop-12-the-chaos-orbit-v2.webp',
    chapterNumber: 12,
  },
  {
    id: 'the-plan',
    title: 'The Plan',
    fromLevel: 1201,
    noticeLine: 'Professor Prometheus turns panic into procedure.',
    src: '/assets/steam-punk/backdrop-13-the-plan-v2.webp',
    chapterNumber: 13,
  },
  {
    id: 'the-harvest',
    title: 'The Harvest',
    fromLevel: 1301,
    noticeLine: 'The crew begins stealing fire from a dead star.',
    src: '/assets/steam-punk/backdrop-14-the-harvest-v2.webp',
    chapterNumber: 14,
  },
  {
    id: 'star-killer',
    title: 'The Star Killer',
    fromLevel: 1401,
    noticeLine: 'The machine becomes legend, assuming the ledger survives.',
    src: '/assets/steam-punk/backdrop-15-the-star-killer-v2.webp',
    chapterNumber: 15,
  },
];

/** Resolve a level to its expedition chapter, clamping invalid levels to chapter one. */
export function steamChapterForLevel(level) {
  const value = Math.max(1, Math.floor(Number(level) || 1));
  return steamChapters.findLast((chapter) => value >= chapter.fromLevel) || steamChapters[0];
}

/** Switch only at chapter boundaries; reuse one image and the existing cached canvas.
 * No extra animation loop, preload fan-out, storage, or gameplay random draws. */
export function installSteamExpedition(r) {
  let current = null;
  let noticeStarted = null;
  const draw = r.draw;
  r.draw = function () {
    const chapter = steamChapterForLevel(r.game.level);
    if (chapter !== current) {
      current = chapter;
      noticeStarted = null;
      r.nebulaImage.src = chapter.src;
      r.backdropReady = false;
      r.markBoardSceneDirty();
      const label = r.root.querySelector('#chapter-name');
      label.textContent = `Chapter ${chapter.chapterNumber} · ${chapter.title}`;
      label.title = chapter.noticeLine;
    }
    if (!r.game.modeRunStarted) noticeStarted = null;
    else if (noticeStarted === null) noticeStarted = r.clock.now();
    const notice = r.root.querySelector('#chapter-notice');
    const text = `Chapter ${chapter.chapterNumber} · ${chapter.title}`;
    if (notice.textContent !== text) notice.textContent = text;
    notice.hidden = noticeStarted === null || r.clock.now() - noticeStarted >= 4600;
    draw();
  };
}
